import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);


const originalPush = VueRouter.prototype.push;                               // 1.解决router路由对象转跳自身页面报错
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};


                                                                              // 2.导入页面组件
import ownInfo from '../views/ownInfo/ownInfo.vue';                           // 2.1.页面-个人信息
import helpInfo from '../views/helpInfo/helpInfo.vue';                         // 2.1.页面-帮助中心
import orderDetail from '../views/orderDetail/orderDetail.vue';               // 2.2.页面-订单详情
import login from '../views/login/login.vue';                                 // 2.3.页面-登录
import everyOrderDetail from '../views/everyOrderDetail/everyOrderDetail.vue';// 2.4.页面-每月对账单详情
import goodsCenter from '../views/goodsCenter/goodsCenter.vue';               // 2.5.页面-商品中心
import orderCenter from '../views/orderCenter/orderCenter.vue';               // 2.6.页面-订单中心
import financeCenter from '../views/financeCenter/financeCenter.vue';         // 2.7.页面-财务中心
import shoppingCar from '../views/shoppingCar/shoppingCar.vue';               // 2.8.页面-购物车
import goodsDetail from '../views/goodsDetail/goodsDetail.vue';               // 2.9.页面-商品详情
import interOrderDetail from '../views/interOrderDetail/interOrderDetail.vue';// 2.10.页面-以导入订单详情
import orderPay from '../views/orderPay/orderPay.vue';                        // 2.11.页面-以已入订单支付
import pay from '../views/pay/pay.vue';                                       // 2.12.页面-支付
import saledOrderDetail from '../views/saledOrderDetail/saledOrderDetail.vue';// 2.13.页面-售后订单详情
import returnOrderDetail from '../views/returnOrderDetail/returnOrderDetail.vue';
import login2 from '../views/login/login2.vue'; 
                                    
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/',
    redirect: '/login2'
  },
  {
    path: '/ownInfo',
    component: ownInfo,
  },
  {
    path: '/helpInfo',
    component: helpInfo,
  },
  {
    path: '/orderDetail',
    component: orderDetail,
  },
  {
    path: '/login',
    component: login,
  },
  {
    path: '/login2',
    component: login2,
  },
  {
    path: '/everyOrderDetail',
    component: everyOrderDetail,
  },
  {
    path: '/goodsCenter',
    component: goodsCenter,
  },
  {
    path: '/orderCenter',
    component: orderCenter,
  },
  {
    path: '/financeCenter',
    component: financeCenter,
  },
  {
    path: '/shoppingCar',
    component: shoppingCar,
  },
  {
    path: '/goodsDetail',
    component: goodsDetail,
  },
  {
    path: '/interOrderDetail',
    component: interOrderDetail,
  },
  {
    path: '/orderPay',
    component: orderPay,
  },
  {
    path: '/pay',
    component: pay,
  },
  {
    path: '/saledOrderDetail',
    component: saledOrderDetail,
  },
  {
    path: '/returnOrderDetail',
    component: returnOrderDetail,
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router
